import type { SegmentListDto } from '@carbonwebmail/contracts'
import type { AsyncState } from './Async.js'

/**
 * The audiences a campaign can be sent to, as select options.
 *
 * "Everyone subscribed" is always first and always present, because it is a
 * real audience rather than a fallback — a campaign with no segment means the
 * whole subscribed list, and that is the one most people pick. It stays offered
 * even when the segments fail to load, so a request that did not come back
 * cannot leave somebody with no audience at all.
 *
 * Written once because the new-campaign form and the composer both need it, and
 * two copies would be two chances for one of them to drop the "everyone" entry
 * or to order them differently.
 */
export function audienceOptions(
  segments: AsyncState<SegmentListDto>,
): readonly (readonly [string, string])[] {
  return [
    ['', 'Everyone subscribed'],
    ...(segments.status === 'ready'
      ? segments.value.segments.map(
          (segment) => [segment.segmentId, segment.name] as readonly [string, string],
        )
      : []),
  ]
}
